//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';
import dskBG from '../../../images/Home/dskBG.png';
import mobBG from '../../../images/Home/mobBG.png';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let subTextFontSize = '2rem';
	let mainTitleFontSize = '4rem';
	let backgroundURL = dskBG;
	let landScreenTextContentContainerMarginTop = '5rem';
	let mainTitleTextTextAlign = 'left';
	let subTextFontSizeTextAlign = 'left';
	let subSubTextFontSizeTextAlign = 'left';
	let foldContainerHeight = '90vh';
	let subTitlesTextColor = 'white';
	let buttonMarginX = '0rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'md') {
		mainTitleFontSize = '3rem';
	}
	if (size === 'sm') {
		subTextFontSize = '1rem';
		mainTitleFontSize = '2rem';
		landScreenTextContentContainerMarginTop = '8rem';
	}
	if (isMobile) {
		subTextFontSize = '2rem';
		backgroundURL = mobBG;
		landScreenTextContentContainerMarginTop = '1rem';
		mainTitleTextTextAlign = 'center';
		foldContainerHeight = '60vh';
		mainTitleFontSize = '2rem';
		subTitlesTextColor = 'black';
		buttonMarginX = 'auto';
		subTextFontSizeTextAlign = 'center';
		subSubTextFontSizeTextAlign = 'center';
	}
	//#endregion

	return {
		foldContainerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				height: foldContainerHeight,
				width: '100%',
				backgroundImage: `url(${backgroundURL})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				maxWidth: '100%',
				paddingLeft: `${minimumMarginX}rem`,
				paddingRight: `${minimumMarginX}rem`,
				felxWrap: 'wrap',
			};
		},
		landScreenTextContentContainerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				marginTop: landScreenTextContentContainerMarginTop,
				marginBottom: 'auto',
			};
		},
		landScreenTextContentContainer: () => {
			let classes = 'col-12 col-sm-7';
			return classes;
		},
		mainTitleTextStyle: () => {
			let style = {
				textAlign: mainTitleTextTextAlign,
				fontSize: mainTitleFontSize,
			};
			return style;
		},
		subTextStyle: () => {
			return {
				color: subTitlesTextColor,
				marginTop: '1rem',
				fontSize: subTextFontSize,
				textAlign: subTextFontSizeTextAlign,
			};
		},
		subSubTextStyle: () => {
			return {
				color: subTitlesTextColor,
				marginTop: '1rem',
				textAlign: subSubTextFontSizeTextAlign,
			};
		},
		buttonStyle: () => {
			return {
				width: 'auto',
				padding: `0.5rem 2rem`,
				margin: `1rem ${buttonMarginX} 0 ${buttonMarginX}`,
				height: `auto`,
			};
		},
		outerContentContainerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				margin: `0 ${minimumMarginX}rem 1rem ${minimumMarginX}rem`,
			};
		},
	};
}

export default Styles;
